var map = {
	"./member_account.svg": "Hs1R",
	"./member_card.svg": "VPEo",
	"./member_customer.svg": "RlGS",
	"./member_home.svg": "EcdE",
	"./member_item.svg": "k+2Y",
	"./member_kgu.svg": "4dvN",
	"./member_order.svg": "FmRt",
	"./member_sponsor.svg": "KKfp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 17